import React from "react";

import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import styled from "styled-components/macro";

class CityComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = { address: "" };
  }

  handleChange = (address) => {
    this.setState({ address });
  };

  handleSelect = async (address) => {
    const results = await geocodeByAddress(address);
    this.props.onChange(results[0]);
    // .then(results => getLatLng(results[0]))
    // .then(latLng => console.log('Success', latLng))
    // .catch(error => console.error('Error', error));
  };

  render() {
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
          return (
            <div>
              <Input
                {...getInputProps({
                  placeholder: "Search Places ...",
                  className: "location-search-input",
                })}
              />
              <div className="autocomplete-dropdown-container">
                {loading && <div key={"input"}>Loading...</div>}
                {suggestions.map((suggestion, index) => {
                  // if (!suggestion.types.includes("locality")) return null

                  const className = suggestion.active
                    ? "suggestion-item--active"
                    : "suggestion-item";
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? {
                        backgroundColor: "#fafafa",
                        cursor: "pointer",
                        padding: "10px 0",
                      }
                    : {
                        backgroundColor: "#ffffff",
                        cursor: "pointer",
                        padding: "10px 0",
                      };
                  return (
                    <div
                      key={`${index}_${suggestion.description}`}
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }}
      </PlacesAutocomplete>
    );
  }
}

export default CityComplete;

const Input = styled.input`
  color: #707070;
  padding: 10px;
  width: 100%;
  font-family: Manrope, serif;
  border: 1px solid #707070;
  //margin: 0 20px;

  &::-webkit-input-placeholder {
    padding-left: 0.25em;
  }
`;
